import React, { useRef, useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import EmailEditor from 'react-email-editor'

export default function EmailEditorComponent(props){
  const[refresh, setRefresh]=useState(0);
  let emailEditorRef = useRef(undefined);
  let done=useRef(false);

  function exportHtml(){emailEditorRef.current.editor.exportHtml((data)=>{
    props.exportHtml(data)
  });};


  if(props.initial_template!=undefined && done.current==false && emailEditorRef.current!=undefined && emailEditorRef.current.loadDesign!=undefined){
      try{
        emailEditorRef.current.loadDesign(props.initial_template);
        emailEditorRef.current.setMergeTags({
        city: {
          name:"City",
          value:"${city}"
        },
        company_name:{
          name:'Company name',
          value:"${company_name}"
        },
        first_name: {
          name: "First Name",
          value: "${first_name}",
        },
        last_name: {
          name: "Last Name",
          value: "${last_name}",
        },
        custom_text1:{
          name:"Custom text 1",
          value:"${custom_text_1}"
        },
        custom_text2:{
          name:"Custom text 2",
          value:"${custom_text_2}"
        },
        custom_text3:{
          name:"Custom text 3",
          value:"${custom_text_3}"
        }
      });
      done.current=true;
    }catch(err){

    }
  }
  if(emailEditorRef.current==undefined){window.setTimeout(function(){setRefresh(refresh+1);},1000);}

    return(
    <Paper style={{position:'relative', width:'calc(100vw - 120px)', minWidth:'1000px', maxWidth:'2000px', height:'calc(100vh - 100px)', maxHeight:'1500px', overflowX:'scroll'}}>
        <EmailEditor
            style={{height:'calc(100vh - 100px)', maxHeight:'1500px'}}
            ref={emailEditorRef}
        />
        <div style={{position:'absolute', display:'flex', justifyContent:'center', alignItems:'center', height:'55px', backgroundColor:'#F0F0F0', width:'350px', right:'0px', bottom:'0px'}}><Button color='primary' variant='contained' onClick={exportHtml}>Save</Button></div>
    </Paper>
  )
}
